import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			flexDirection: 'column',
			width: theme.spacing(14.12),
			height: theme.spacing(14.12),
			backgroundColor: ({ bgColour }) => bgColour,
			marginRight: theme.spacing(2.75),
			borderRadius: theme.spacing(1.25),

			'&:last-child': {
				marginRight: 0,
			},

			[theme.breakpoints.down('xs')]: {
				height: `calc(${theme.spacing(9)} + 1vw)`,
				width: `calc(${theme.spacing(9)} + 1vw)`,
				marginRight: theme.spacing(1),
			},
		},
		value: {
			color: theme.palette.primary.main,
			fontSize: theme.spacing(5),
			fontWeight: 700,

			[theme.breakpoints.down('xs')]: {
				fontSize: `calc(${theme.spacing(3)} + 0.5vw)`,
			},
		},
		label: {
			textAlign: 'center',
			color: ({ bgColour }) => theme.palette.getContrastText(bgColour),

			'& > p': {
				fontSize: theme.spacing(2.25),
				fontWeight: 400,
			},

			[theme.breakpoints.down('xs')]: {
				'& > p': {
					fontSize: `calc(${theme.spacing(1.5)} + 0.5vw)`,
				},
			},
		},
	}),
	{ name: 'CallToAction-Cta18-timer-item' },
)

export default useStyles
